export default __webpack_public_path__ + "static/media/discover.979e702e.jpg";